import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import request from 'axios'
import { glasConfig } from '../constants/Config'
import * as Fetch from '../util/Fetch'
import DialogConfirmPayoff from '../components/Modals/ModalConfirmPayoff/Dialogs/DialogConfirmPayoff'
import RewardInfo from './Reward/RewardInfo'
import warningFill from '../assets/warning-fill.png'
import Snackbar from 'material-ui/Snackbar'
import moment from 'moment'
import { PAYOFF_STATUS } from '../util/StellaConstant'

export default class RewardRegistForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			registflg: 0, // 0:申請なし、1:申請あり
			transferdate: '',
			registdate: '',
			openDialogPayoff: false,
			bankaccount: 0, // 0:銀行情報なし、1:あり
			commission: 0, // 精算手数料
			bankminpay: Fetch.checkChangeFeeDate()
				? glasConfig.payoff_min_new
				: glasConfig.payoff_min, // 銀行振込による精算の最低金額
			reward: 0,
			taxsalary: 0,
			pointtransfer: 0,
			isinvoice: false,
			is_regis_invoice: false,
			invoice_adjustment_rate: 0,
			point: 0,
			isAutoPayoff: true,
			openSnackbar: false,
			payoff_status: 0,
			current_md: moment().format('MM-DD'),
			point_request_auto_payoff: 0,
			payoff_processing: false,
			loading: true,
			is_invoice_applied: false,
			invoice_adjustment_amount: 0
		}
	}

	componentWillMount() {
		const { MyProfile } = this.props
		this.setState({
			point: MyProfile.data.point,
			loading: true
		})
		this.comfirmRegist()
	}

	/**
	 * 精算の確認
	 */
	comfirmRegist() {
		const url = glasConfig.url_outside + glasConfig.path_payment
		const options = {
			method: 'GET',
			url: url,
			headers: {
				Authorization: localStorage.getItem('token'),
			},
			json: true,
		}

		request(options)
			.then((response) => {
				if (response.data.code === 0) {
					this.setState({
						transferdate: moment(response.data.data.transferdate, 'YYYY年M月DD日(ddd)').format('YYYY年MM月DD日(ddd)'),
						registflg: response.data.data.registflg,
						bankaccount: response.data.data.bankaccount,
						commission: response.data.data.commission,
						bankminpay: response.data.data.bankminpay,
						reward: response.data.data.reward,
						taxsalary: response.data.data.taxsalary,
						pointtransfer: response.data.data.pointtransfer,
						isinvoice: response.data.data.isinvoice,
						is_regis_invoice: response.data.data.is_regis_invoice,
						invoice_adjustment_rate: response.data.data.invoice_adjustment_rate || 0,
						payoff_status: response.data.data.payoff_status,
						current_md: response.data.data.current_md,
						point_request_auto_payoff: response.data.data.point,
						payoff_processing: response.data.data.payoff_processing,
						is_invoice_applied: response.data.data.is_invoice_applied,
						invoice_adjustment_amount: response.data.data.invoice_adjustment_amount,
						loading: false
					})
				}
			})
			.catch((error) => {
				this.setState({ loading: false })
				//throw error
			})
	}

	/**
	 * 精算の申請
	 */
	handlerRegist() {
		const { MyProfile } = this.props

		const url = glasConfig.url_outside + glasConfig.path_payment
		const params = {
			point: MyProfile.data.point,
		}
		const options = {
			method: 'PUT',
			url: url,
			data: params,
			headers: {
				Authorization: localStorage.getItem('token'),
				'Content-Type': 'application/json',
			},
			json: true,
		}

		request(options)
			.then((response) => {
				if (response.data.code === 0) {
					this.setState({ registflg: 1 })

					const tellerId = Fetch.tellerId()
					request.put(
						glasConfig.url_base +
						glasConfig.update_mission_introduce,
						{
							missionType: 'REQUEST_PAYOFF',
							tellerId,
						},
						{
							headers: {
								Authorization: localStorage.getItem('token'),
							},
						}
					)
					this.setState({
						openDialogPayoff: false,
						point: MyProfile.data.point
					})
				}
			})
			.catch((error) => {
				this.setState({ openDialogPayoff: false })
				//throw error
			})
	}

	/**
	 * 精算申請可能かの判定
	 * return {boolean} true:可能
	 */
	chkRegist() {
		const { MyProfile } = this.props
		if (
			this.state.bankaccount === 1 &&
			this.state.registflg === 0 &&
			this.state.bankminpay <= MyProfile.data.point
		) {
			return true
		}
		return false
	}

	submitButtonPayOff() {
		const { MyProfile } = this.props
		this.setState({
			point: MyProfile.data.point
		})
		this.comfirmRegist()
		this.setState({ openDialogPayoff: true })
	}

	handleManualPayoff() {
		if (this.props.MyProfile.data.verifyAge === 'Verified') {
			this.setState({ isAutoPayoff: false })
		} else {
			this.setState({ openSnackbar: true })
		}
	}

	render() {
		const { MyProfile } = this.props

		const point = Math.floor(this.state.point)
		const currentMoment = moment(this.state.current_md, 'MM-DD')
		const dateAutoPayoff = currentMoment.date() <= 5
			? currentMoment.format('MM月5日')
			: moment(this.state.current_md, 'MM-DD').add(1, 'months').format('MM月5日')
		const dateTransferEstimate = moment(this.state.current_md, 'MM-DD').date() <= 5
			? moment(this.state.current_md, 'MM-DD').format('MM月10日')
			: moment(this.state.current_md, 'MM-DD').add(1, 'months').format('MM月10日')
		let textStatus = ''
		let bgStatus = ''
		let labelNote = ''
		let disabledManualPayoff = false
		if (this.state.payoff_status === PAYOFF_STATUS.READY) {
			textStatus = '精算前'
			bgStatus = '#6ad6cb'
			labelNote = <span style={{ fontWeight: 300 }}>次回精算日は <span style={{ fontWeight: 600 }}>{dateAutoPayoff}</span> です</span>
			disabledManualPayoff = false
		} else if (this.state.payoff_status === PAYOFF_STATUS.PROCESS) {
			textStatus = '精算処理中'
			bgStatus = '#ff9000'
			labelNote = '現在精算処理中です'
			disabledManualPayoff = true
		} else if (this.state.payoff_status === PAYOFF_STATUS.WAITING_TRANSFER) {
			textStatus = '振込完了予定'
			bgStatus = '#eb4646'
			labelNote = '10日までに振込完了予定です'
			disabledManualPayoff = true
		}


		let ClassCheckOut = 'checkout-box'
		if (this.state.registflg === 1) {
			ClassCheckOut = ClassCheckOut + ' checkout_done'
		} else {
			if (this.state.isAutoPayoff) {
				ClassCheckOut = ClassCheckOut + ' checkout_ng'
			} else {
				ClassCheckOut = ClassCheckOut + ' checkout_ok'
			}
		}

		const point_request = this.state.isAutoPayoff && this.state.payoff_status !== PAYOFF_STATUS.READY ? this.state.point_request_auto_payoff : point
		// const taxInvoice = this.state.is_regis_invoice ? 0 : this.state.payoff_status === PAYOFF_STATUS.READY ? Math.floor(this.state.invoice_adjustment_rate * point / 100) : this.state.invoice_adjustment_amount

		let taxInvoice = 0
		let showTaxInvoice = false
		if (this.state.isAutoPayoff) {
			if (this.state.payoff_status == PAYOFF_STATUS.READY) {
				showTaxInvoice = !this.state.is_regis_invoice
				if (this.state.is_regis_invoice) {
					taxInvoice = 0
				} else {
					taxInvoice = Math.floor(this.state.invoice_adjustment_rate * point / 100)
				}
			} else {
				showTaxInvoice = !this.state.is_invoice_applied
				if (this.state.is_invoice_applied) {
					taxInvoice = 0
				} else {
					taxInvoice = this.state.invoice_adjustment_amount
				}
			}
		} else {
			showTaxInvoice = !this.state.is_regis_invoice
			taxInvoice = Math.floor(this.state.invoice_adjustment_rate * point / 100)
		}

		return (
			<div className="checkout-box-wrap" style={{ fontFamily: 'Hiragino Kaku Gothic Pro' }}>
				<div className="primary-title">
					<h1 className="primary-title__main">
						報酬確認・精算 -
						<span style={{ fontSize: '15px' }}>{' '}{this.state.isAutoPayoff ? '定期精算' : 'クイック精算'}</span>
					</h1>
				</div>
				<div className="checkout-box__inner">
					<div>
						<div className={ClassCheckOut}>
							{this.state.registflg === 1 && !this.state.isAutoPayoff ? (
								<div>
									<p className="checkout-box__title">報酬確定額</p>
									<p className="checkout-box__text" style={{ marginTop: 24 }}>
										精算申請が完了しました
										<br />
										お振込予定日は
										<strong style={{ fontWeight: 600 }} className="checkout-box__emphasis">
											{this.state.transferdate}
										</strong>
										です
										<br />
										いましばらくお待ちくださいませ
									</p>
								</div>
							) : (
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<table className="table-payoff">
										<tbody>
											<tr >
												<th >
													精算申請ポイント
												</th>
												<td >
													{Fetch.formatNumber(point_request ? point_request : 0)}PT
												</td>
											</tr>
											<tr >
												<th>
													・基本報酬
												</th>
												<td>
													{Fetch.formatNumber(this.state.reward)}円
												</td>
											</tr>
											<tr >
												<th>
													・消費税
												</th>
												<td>
													{Fetch.formatNumber(this.state.taxsalary)}円
												</td>
											</tr>
											{showTaxInvoice && <tr>
												<th>
													・インボイス制度調整額
												</th>
												<td>
													-{Fetch.formatNumber(taxInvoice)}円
												</td>
											</tr>}
											{!this.state.isAutoPayoff && <tr className="table-payoff__border-bottom">
												<th>
													・事務手数料
												</th>
												<td>
													-{Fetch.formatNumber(this.state.commission)}円
												</td>
											</tr>}
											{
												this.state.isAutoPayoff && <tr className="table-payoff__border-top" style={{ paddingTop: 16 }}>
													<td colSpan={2} style={{ paddingTop: 16, paddingBottom: 0 }}>
														<div style={{ paddingBlock: 2, textAlign: 'center', fontSize: 10, fontWeight: '600', color: '#fff', backgroundColor: bgStatus, borderRadius: 8 }}>{textStatus}</div>
													</td>
												</tr>
											}
											<tr >
												<th style={{ verticalAlign: 'top' }}>
													支払い予定額(税込)
												</th>
												<td
												>
													<span
														style={{
															color: this.state.bankminpay > MyProfile.data.point && this.state.payoff_status === PAYOFF_STATUS.READY ? '#a1a1a8' : '#11ad9d',
															textDecoration: this.state.bankminpay > MyProfile.data.point && this.state.payoff_status === PAYOFF_STATUS.READY ? 'line-through' : 'none'
														}}>
														{Fetch.formatNumber(this.state.isAutoPayoff ? this.state.reward + this.state.taxsalary - taxInvoice : this.state.pointtransfer)}
														円
													</span>
													{this.state.bankminpay > MyProfile.data.point && this.state.payoff_status === PAYOFF_STATUS.READY &&
														<span style={{ textDecoration: 'none', color: '#ec407a', fontSize: 13, fontWeight: 300 }}><br />精算可能額まで<br />あと<span style={{ fontWeight: 600 }}>{Fetch.formatNumber(this.state.bankminpay - Math.floor(MyProfile.data.point))}PT</span>必要です</span>}
												</td>
											</tr>
										</tbody>
									</table>

									{
										!this.state.isAutoPayoff ? (
											<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
												<button
													className="btn-raised color_default"
													style={{ width: 240, fontSize: 15, color: 'white' }}
													disabled={!this.chkRegist()}
													onClick={() => this.submitButtonPayOff()}
												>
													クイック精算を申請
												</button>
												<span>
													ただいま精算申請されますと<br />
													お振込予定日は
													<span style={{ fontWeight: 600, color: '#ec407a' }}>{this.state.transferdate}</span>
													となります
												</span>
											</div>
										)
											:
											(
												<>
													<div className="note-time-transfer">
														<div style={{ color: '#ec407a', display: 'flex', alignItems: 'center', }}>
															<img
																src={warningFill}
																alt="Warning"
																style={{ width: 12, height: 12, marginBottom: 0, marginRight: 4 }}
															/>
															<span>{this.state.payoff_status === PAYOFF_STATUS.READY && this.state.bankminpay > MyProfile.data.point ? '精算予定ポイントが足りません' : labelNote}</span>
														</div>
														{this.state.payoff_status === PAYOFF_STATUS.READY && this.state.bankminpay <= MyProfile.data.point && <div style={{ borderTop: 'solid 1px #ec407a', paddingTop: 2 }}>
															<span style={{ color: '#757575' }}>振込予定日：<span style={{ fontWeight: 600 }}>{dateTransferEstimate}</span>まで</span>
														</div>
														}
													</div>
													<Link to="/home/staffblog/detail/14910" style={{ fontSize: 10, color: '#afafb6', marginTop: 6, textDecoration: 'underline', cursor: 'pointer' }}>詳しくはこちら</Link>
												</>
											)
									}
									{
										!this.state.loading && this.state.bankaccount === 0 && this.state.isAutoPayoff && (
											<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 24, gap: 8 }}>
												<strong className="checkout-box__emphasis">
													お振込先が未登録のため精算できません
												</strong>
												<Link
													className="btn-raised"
													style={{ backgroundColor: '#ec407a', color: '#fff', paddingInline: 30, fontSize: 15 }}
													to="/home/setting/bank/top"
												>
													振込先銀行口座を登録する
												</Link>
											</div>
										)
									}
									<DialogConfirmPayoff
										openDialogPayoff={this.state.openDialogPayoff}
										closeDialogPayoff={() => this.setState({ openDialogPayoff: false })}
										transferAmount={Fetch.formatNumber(this.state.pointtransfer)}
										bankaccount={this.state.bankaccount}
										checkRegist={this.chkRegist()}
										myProfile={MyProfile}
										handleRegist={() => this.handlerRegist()}
									/>
								</div>

							)}
						</div>
						{this.state.isAutoPayoff && (
							<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, gap: 12 }}>
								{this.state.payoff_status === PAYOFF_STATUS.READY ?
									<span style={{ fontSize: 12, color: '#262626', fontWeight: '600' }}>
										「定期精算より早めに精算したい」<span style={{ fontWeight: '300' }}>という方は↓</span>
									</span>
									: <span style={{ fontSize: 12, color: '#262626' }}>
										精算処理中はクイック精算をご利用できません
									</span>}
								<button
									onClick={() => this.handleManualPayoff()}
									className='btn-raised color_default'
									style={{ width: 240, fontSize: 15, color: 'white' }}
									disabled={this.state.bankminpay > MyProfile.data.point || this.state.bankaccount === 0 || disabledManualPayoff || this.state.payoff_processing}
								>クイック精算を申請</button>
							</div>
						)}
					</div>
					<RewardInfo commission={this.state.commission} is_regis_invoice={this.state.is_regis_invoice} isAutoPayoff={this.state.isAutoPayoff} />
				</div>
				{!this.state.isAutoPayoff && <button onClick={() => {
					this.setState({ isAutoPayoff: true })
					this.comfirmRegist()
				}} className='checkout-box__btn-back'>戻る</button>}
				<Snackbar
					open={this.state.openSnackbar}
					message={'まずは身分証を提出してください'}
					autoHideDuration={5000}
					onRequestClose={() => this.setState({ openSnackbar: false })}
					className="message-dialog"
				/>
			</div>

		)
	}
}

const CheckOutext = ({ MyProfile, data }) => {
	const restPoint = data.bankminpay - MyProfile.data.point
	if (data.bankaccount === 0) {
		return (
			<strong className="checkout-box__emphasis">
				お振込先が未登録のため精算できません
			</strong>
		)
	} else {
		if (data.registflg === 0) {
			if (data.bankminpay <= MyProfile.data.point) {
				return (
					<span>
						ただいま精算申請されますと
						<br />
						お振込予定日は{' '}
						<strong className="checkout-box__emphasis">
							{data.transferdate}
						</strong>{' '}
						となります
					</span>
				)
			} else {
				return (
					<strong className="checkout-box__emphasis">
						精算可能額まであと
						<br />
						{Fetch.formatNumber(
							Number.isInteger(restPoint)
								? restPoint
								: restPoint.toFixed(2)
						)}
						円（
						{Fetch.formatNumber(
							Number.isInteger(restPoint)
								? restPoint
								: restPoint.toFixed(2)
						)}
						PT）必要です
					</strong>
				)
			}
		}
	}
}
